
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class TextFieldWithConfirm extends Vue {
  @Prop(String) readonly value: string | null | undefined
  @Prop(Boolean) readonly confirmed!: boolean
  @Prop(String) readonly label: string | null | undefined
  @Prop(Boolean) readonly readonly: boolean | undefined
  @Prop(Boolean) readonly disabled: boolean | undefined
  @Prop(Array) readonly rules!: ((unknown) => string | boolean)[]
  @Prop(String) readonly appendIcon: string | null | undefined

  text: string | null | undefined = null
  isConfirmed = false

  created() {
    console.log(`${this.constructor.name}: created()`); // eslint-disable-line no-console
    this.text = this.value;
    this.isConfirmed = this.confirmed;
  }

  @Watch('text')
  onTextChange(val: string) {
    if (this.value !== val) {
      console.log(`${this.constructor.name}: onTextChange(${val})`); // eslint-disable-line no-console
      this.$emit('input', val);
    } else {
      console.log(`${this.constructor.name}: onTextChange(${val}) ignorato`); // eslint-disable-line no-console
    }
  }

  @Watch('isConfirmed')
  onIsConfirmedChange(val: boolean) {
    if (this.confirmed !== val) {
      console.log(`${this.constructor.name}: onIsConfirmedChange(${val})`); // eslint-disable-line no-console
      this.$emit('confirm', val);
    } else {
      console.log(`${this.constructor.name}: onIsConfirmedChange(${val}) ignorato`); // eslint-disable-line no-console
    }
  }

  get isValid(): boolean | string {
    if (!this.rules) return true;

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < this.rules.length; i++) {
      const result = this.rules[i](this.text);
      if (result !== true) return result;
    }

    return true;
  }

  @Watch('isValid')
  onIsValidChange(val: boolean | string) {
    console.log(`${this.constructor.name}: onIsValidChange(${val})`); // eslint-disable-line no-console
    if (val !== true && this.isConfirmed === true) {
      this.isConfirmed = false;
    }
  }

  get lineClass(): string {
    return this.isConfirmed ? 'selected' : '';
  }

  get lineIcon(): string | null {
    if (this.appendIcon) return this.appendIcon;
    return null;
    // return this.isConfirmed ? 'mdi-check-decagram' : null;
  }

  get tooltipText(): string {
    if (this.isValid === true) {
      return this.isConfirmed ? 'Confermato' : 'Premi per confermare';
    }

    return 'Non confermato';
  }
}

